import { OidcIdentityProvidersApi, UpdateOidcIdentityProviderDto } from '../../../../api-client';
import { useMutation, UseMutationResult } from 'react-query';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../../common';

type UseUpdateOidcProvider = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<void>,
      ErrorResponse,
      { id: string; updateIdentityProviderDto: UpdateOidcIdentityProviderDto }
    >,
    'mutationFn'
  >,
) => UseMutationResult<
  AxiosResponse<void>,
  ErrorResponse,
  { id: string; updateIdentityProviderDto: UpdateOidcIdentityProviderDto }
>;

export const useUpdateOidcProvider: UseUpdateOidcProvider = (
  options,
) => {
  const oidcIdentityProvidersApi = new OidcIdentityProvidersApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;
  return useMutation(
    ({ id, updateIdentityProviderDto }) =>
      oidcIdentityProvidersApi.updateOidcProvider(id, tenantId, updateIdentityProviderDto),
    options,
  );
};
